import { render, staticRenderFns } from "./settingsComponent.vue?vue&type=template&id=4d97b11c"
import script from "./settingsComponent.vue?vue&type=script&lang=js"
export * from "./settingsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports